import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchRelatedPosts, updateLike } from './relatedPostsAPI';
const initialState = {
    relatedPosts: [],
    loading: false,
    errorMessage: '',
    isError: '',
};

export const getRelatedPosts = createAsyncThunk(
    'relatedPosts/fetchRelatedPosts',
    async (info) => {
        const data = await fetchRelatedPosts(info);
        return data;

        // The value we return becomes the `fulfilled` action payload
    }
);

export const relatedPostsSlice = createSlice({
    name: 'relatedPost',
    initialState,

    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getRelatedPosts.pending, (state) => {
                state.loading = true;
                state.errorMessage = '';
                state.isError = false;
                state.relatedPosts = [];

            })
            .addCase(getRelatedPosts.fulfilled, (state, action) => {
                state.loading = false;
                state.errorMessage = '';
                state.isError = false;
                state.relatedPosts = action.payload;
            })
            .addCase(getRelatedPosts.rejected, (state, action) => {
                state.loading = false;
                state.errorMessage = action.error;
                state.isError = true;
                state.relatedPosts = [];
            })
    },
});


export default relatedPostsSlice.reducer;
